import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Nav from "../components/Nav";
import { api, formatApiError } from "../lib/api";
import { CheckCircle } from "@phosphor-icons/react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!token) return setError("Reset token missing — please use the link from your email.");
    if (form.password.length < 6) return setError("Password must be at least 6 characters");
    if (form.password !== form.confirm) return setError("Passwords don't match");
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: form.password });
      setDone(true);
      setTimeout(() => nav("/cardholder/login"), 2500);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <Nav />
      <section className="border-b border-black bg-[color:var(--cc-bg-2)]">
        <div className="max-w-md mx-auto px-4 py-12 sm:py-16">
          <div className="label-tag text-neutral-500">Reset password</div>
          <h1 className="font-display font-black text-3xl mt-1">Choose a new password</h1>

          {done ? (
            <div className="mt-8 bg-[color:var(--cc-yellow)] border border-black p-6" data-testid="reset-done">
              <CheckCircle size={28} weight="fill" />
              <div className="font-display font-black text-xl mt-2">Password changed</div>
              <p className="mt-2 text-sm">Redirecting you to the login page…</p>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-4 bg-white border border-black p-6" data-testid="reset-form">
              <div>
                <label className="label-tag">New password</label>
                <input type="password" className="mt-1 w-full px-4 py-3 border border-black outline-none" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="reset-password" required />
              </div>
              <div>
                <label className="label-tag">Confirm password</label>
                <input type="password" className="mt-1 w-full px-4 py-3 border border-black outline-none" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="reset-confirm" required />
              </div>
              {error && <div className="label-tag text-red-600" data-testid="reset-error">{error}</div>}
              <button type="submit" disabled={submitting} className="w-full bg-black text-white label-tag px-4 py-4 brutal-btn disabled:opacity-60" data-testid="reset-submit">
                {submitting ? "Saving…" : "Set new password"}
              </button>
              <Link to="/cardholder/login" className="block text-center label-tag underline">Back to login</Link>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}
